import CustomDomainService from "@/pages/common/trend/service/CustomDomainService";
import { RESET_STATE, SET } from "@/stores/CommumActionTypes";

const mutations = {
	[SET]: (state, signal) =>
	{
		state.selectedCustomDomainSignal = signal;
	},
	[RESET_STATE]: (state) =>
	{
		state.selectedCustomDomainSignal = CustomDomainService.EmptyCustomDomainStatefactory();
	},
};

export default { mutations };